module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/wood-horse-3eb5928785a3d6a2a387dafd0654ae19.svg";